import { render } from "./SystemInfo.vue?vue&type=template&id=d6117b60"
import script from "./SystemInfo.vue?vue&type=script&lang=js"
export * from "./SystemInfo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\bp-kmiyajima\\Documents\\Projects\\noritz-protal\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__